
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/[slug]/toys",
      function () {
        return require("private-next-pages/user/[slug]/toys/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/[slug]/toys"])
      });
    }
  